/**
 * Spinner — a small, self-contained loading indicator for the nb-* dashboards
 * design system. A rotating ring (CSS border trick) sized by `size`, tinted by
 * `color` (defaults to the brand primary). Carries its own `@keyframes` so it
 * works without any global animation utility.
 *
 * Decorative by default (`aria-hidden`); pair it with a visible/asserted label
 * in the surrounding region (e.g. a `role="status"` container) for a11y rather
 * than announcing the spinner itself.
 */
export interface SpinnerProps {
  /** Diameter in px. Default 24. */
  size?: number;
  /** Ring color. Default `var(--nb-primary)`. */
  color?: string;
  /** Stroke width in px. Default 2. */
  thickness?: number;
}

export function Spinner({ size = 24, color = 'var(--nb-primary)', thickness = 2 }: SpinnerProps) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        border: `${thickness}px solid ${color}`,
        borderTopColor: 'transparent',
        animation: 'nb-spin 1s linear infinite',
      }}
    >
      <style>
        {'@keyframes nb-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}'}
      </style>
    </span>
  );
}
